import paymentInstance from '../instance'
import paymentModalLoginInstance from '../modalLoginInstance'

const deleteQrPaymentSession = (sessionId, hasModalLogin = false) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance)
		.delete(`/qrPaymentSessions/${sessionId}`)
}

export default deleteQrPaymentSession
